let url = window.location.href
if (url.indexOf('/products') != -1) {
  document.addEventListener('DOMContentLoaded', function () {
    let jsonld = JSON.parse(document.querySelector('[data-id="product-json"]').innerText)
    let product = jsonld
    dataLayer.push({
      event: 'ecommerce',
      event_name: 'ViewContent',
      contents: [
        {
          id: product.id,
          name: product.name,
          quantity: 1,
          price: product.price
        }
      ]
    })

    let atcButton = document.querySelector('.product-form__submit')
    atcButton.addEventListener('click', dataLayerProductSubmit)
    let checkoutButton = document.querySelector('button[name="checkout"]')
    checkoutButton.addEventListener('click', dataLayerCheckoutSubmit)
    function dataLayerProductSubmit() {
      //when they click add to cart button
      let variant_id = document.querySelector('input[name="id"]').value
      variant_id = parseInt(variant_id)
      let variant_title = product.name
      let addedQuantity = document.querySelector('.quantity__input').value
      addedQuantity = parseInt(addedQuantity)
      for (var i = 0; i < product.offers.length; i++) {
        if (variant_id === product.offers[i].id) {
          variant_title = variant_title + ' / ' + product.offers[i].title
        }
      }
      dataLayer.push({
        event: 'ecommerce',
        event_name: 'AddToCart',
        subtotal: product.price,
        contents: [{ id: variant_id, name: variant_title, quantity: addedQuantity }]
      })
    }
  })
} else if (url.indexOf('/cart') != -1) {
  let checkoutButton = document.getElementById('checkout')
  checkoutButton.addEventListener('click', dataLayerCheckoutSubmit)
}

function dataLayerCheckoutSubmit(e) {
  e.preventDefault()
  let xhttp = new XMLHttpRequest()
  xhttp.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      // Typical action to be performed when the document is ready:
      let cart = JSON.parse(xhttp.responseText)
      let item_array = []
      for (var i = 0; i < cart.items.length; i++) {
        item_array.push({
          id: cart.items[i].id,
          name: cart.items[i].title,
          quantity: cart.items[i].quantity
        })
      }
      dataLayer.push({
        event: 'ecommerce',
        event_name: 'InitiateCheckout',
        contents: item_array
      })
      window.location.href = '/checkout'
    }
  }
  xhttp.open('GET', '/cart.js', true)
  xhttp.send()
}
